module.exports = __webpack_public_path__ + "static/media/university-2.435e4dc7.png";